import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PageHero } from "../components/site/Shared";
import { Reveal } from "../components/site/Reveal";
import { INSIGHTS } from "../data/content";
import { fetchInsights } from "../lib/api";
import { ArrowUpRight } from "lucide-react";

const AREAS = [
  "Trusted advisory",
  "Leadership and judgment",
  "Institutional trust",
  "Relationships and strategy",
  "Cross-cultural leadership",
  "Jewish–Christian relations",
  "Jewish–Latino relations",
  "Faith and public life",
  "Strategic partnerships",
  "Convening",
  "History and memory",
  "Philanthropy",
  "Institutional stewardship",
];

export default function Insights() {
  const [articles, setArticles] = useState(INSIGHTS);

  useEffect(() => {
    fetchInsights()
      .then((data) => {
        if (Array.isArray(data) && data.length) setArticles(data);
      })
      .catch(() => {});
  }, []);

  return (
    <div data-testid="insights-page">
      <PageHero
        eyebrow="Insights"
        titleLines={["Ideas for leaders", "navigating consequence."]}
        lede="Yadid Insights brings together observations and reflections from the intersections where our work takes place."
      />

      {/* Article index */}
      <section className="bg-ivory">
        <div className="yadid-container border-t border-stone">
          {articles.map((a, i) => (
            <Reveal key={a.slug} delay={(i % 3) * 0.05}>
              <Link
                to={`/insights/${a.slug}`}
                data-testid={`insight-${a.slug}`}
                className="group grid grid-cols-1 lg:grid-cols-12 gap-4 lg:gap-10 py-10 md:py-14 border-b border-stone transition-colors duration-500 hover:bg-stone-soft/40"
              >
                <div className="lg:col-span-3">
                  <p className="eyebrow text-brass">{a.category}</p>
                  <p className="mt-3 text-sm text-ink/50 font-light">{a.date}</p>
                </div>
                <div className="lg:col-span-8 lg:col-start-4">
                  <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-ink tracking-[-0.02em] leading-[1.08] flex items-start gap-3">
                    <span>{a.title}</span>
                    <ArrowUpRight
                      className="mt-2 text-brass opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-500 shrink-0"
                      size={26}
                    />
                  </h2>
                  <p className="mt-5 text-lg text-ink/65 font-light leading-relaxed max-w-2xl">
                    {a.excerpt}
                  </p>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>

      {/* Areas of exploration */}
      <section className="bg-stone-soft/40 border-y border-stone">
        <div className="yadid-container py-24 md:py-32">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
            <div className="lg:col-span-4">
              <Reveal>
                <p className="eyebrow text-brass mb-6">Areas of Exploration</p>
                <h2 className="font-serif text-3xl md:text-4xl text-ink tracking-[-0.02em] leading-tight">
                  We publish when there is something worth saying.
                </h2>
                <p className="mt-6 text-ink/60 font-light leading-relaxed">
                  Not simply because the content calendar requires it.
                </p>
              </Reveal>
            </div>
            <div className="lg:col-span-7 lg:col-start-6">
              <div className="flex flex-wrap gap-3">
                {AREAS.map((area, i) => (
                  <Reveal key={area} delay={i * 0.02}>
                    <span className="inline-block border border-stone px-5 py-2.5 text-sm text-ink/70 font-light bg-ivory">
                      {area}
                    </span>
                  </Reveal>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
